const testimonialTabNavs = document.querySelectorAll(".js-testimonial-tab-nav");
const testimonialTabContents = document.querySelectorAll(".js-testimonial-tab-content");

testimonialTabNavs.forEach((nav) => {
  nav.addEventListener("click", (event) => {
    event.preventDefault();

    const tabId = nav.getAttribute("data-tab");
    const tab = document.querySelector(`.js-testimonial-tab-content[data-tab='${tabId}']`);

    if (!tab) {
      return;
    }

    testimonialTabNavs.forEach((el) => el.classList.remove("current"));
    testimonialTabContents.forEach((el) => el.classList.remove("current"));

    nav.classList.add("current");
    tab.classList.add("current");

    requestAnimationFrame(() => {
      if (typeof refreshGridArrowsIn === "function") {
        refreshGridArrowsIn(tab);
      }
    });
  });
});